import React from "react";
import {SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { EmailLayout } from '../../../../../models';
import i18n from '../../../../../locales/i18n';
import "./SortableList.css";

const DragHandle = SortableHandle(() => {
    const hint = i18n.t('common.drag_to_reorder');
    return (
        <span className="drag-handle" title={hint} aria-label={hint}>
            <i className="fa fa-bars" aria-hidden="true" />
        </span>
    );
});

const SortableItem = SortableElement(({ value }) => (
    <li>
        <DragHandle />
        { value }
    </li>
));

const SortableItems = SortableContainer(({ items }) => {
    return (
        <ul>
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={value} />
            ))}
        </ul>
        );
});

const SortableList = props => {
    const { layout, widgets, fonts, currentWidget, onClick, onSort } = props;

    const onSortEnd = ({oldIndex, newIndex}) => {
        onSort && onSort(oldIndex, newIndex);
    };

    const editableContent = (content) => {
        return (
            <div className="editable-content" >{ content }</div>
        );
    };

    const items = widgets.map((data, index) => {
        const widget = EmailLayout.createWidget(data);

        const widgetContent = (
            <div>
                { widget?.getPreview({
                    layout,
                    inEdition: props.inEdition,
                    lang: props.lang,
                    setting: props.setting,
                    preview_context: props.preview_context,
                    fonts,
                    programmation: props.programmation,
                    place: props.place,
                    tickettype: props.tickettype,
                    pricing: props.pricing
                })}
            </div>
        );

        return (
            <div onClick={ () => { onClick(widget, index); }} tabIndex={ -1 } className={ `${currentWidget?.id === widget?.id ? 'active' : ''}` } style={{position: 'relative'}}>
                { props.inEdition ? editableContent(widgetContent) : widgetContent }
            </div>
        );
    });

    return (
        <div className={`SortableList ${props.inEdition ? 'inEdition' : ''}`}>
            <SortableItems items={ items } onSortEnd={ onSortEnd } useDragHandle />
        </div>
    );
};

export default SortableList;
